module.exports = __webpack_public_path__ + "assets/media/x.d95552e3.mp4";